import React, { useState } from 'react';

interface Student {
  id: string;
  name: string;
  avatar: string;
}

interface AttendanceModalProps {
  isOpen: boolean;
  onClose: () => void;
  students: Student[];
  onConfirmAttendance: (selectedStudents: Student[]) => void;
}

const AttendanceModal: React.FC<AttendanceModalProps> = ({
  isOpen,
  onClose,
  students,
  onConfirmAttendance
}) => {
  const [selectedStudents, setSelectedStudents] = useState<Set<string>>(new Set());

  if (!isOpen) return null;

  const handleStudentClick = (studentId: string) => {
    const newSelected = new Set(selectedStudents);
    if (newSelected.has(studentId)) {
      newSelected.delete(studentId);
    } else {
      newSelected.add(studentId);
    }
    setSelectedStudents(newSelected);
  };

  const handleAllSelected = () => {
    const attendingStudents = students.filter(student => selectedStudents.has(student.id));
    onConfirmAttendance(attendingStudents);
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="attendance-modal-overlay" onClick={handleOverlayClick}>
      <div className="attendance-modal" style={{ display: 'flex', flexDirection: 'column' }}>
        <div className="attendance-modal-header">
          <h2>Squad up!</h2>
          <button className="close-modal-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="attendance-modal-content" style={{ overflowY: 'auto', flexGrow: 1 }}>
          <p className="attendance-instructions">
            Click on each student who is present today
          </p>
          
          <div className="attendance-student-grid">
            {students.map((student) => (
              <div
                key={student.id}
                className={`attendance-student-item ${
                  selectedStudents.has(student.id) ? 'selected' : ''
                }`}
                onClick={() => handleStudentClick(student.id)}
              >
                <div className="attendance-student-avatar-container">
                  <img
                    src={student.avatar}
                    alt={student.name}
                    className="attendance-student-avatar"
                  />
                  {selectedStudents.has(student.id) && (
                    <div className="attendance-checkmark">✓</div>
                  )}
                </div>
                <span className="attendance-student-name">{student.name}</span>
              </div>
            ))}
          </div>
          
        </div>
        <div className="attendance-modal-footer" style={{ flexShrink: 0, padding: '1rem 2rem' }}>
            <div className="selected-count">
              {selectedStudents.size} of {students.length} selected
            </div>
            <button 
              className="all-selected-btn"
              onClick={handleAllSelected}
              disabled={selectedStudents.size === 0}
            >
              All Selected
            </button>
          </div>
      </div>
    </div>
  );
};

export default AttendanceModal;